import { render, staticRenderFns } from "./WaybillDetail.vue?vue&type=template&id=b1abb5a2&scoped=true&"
import script from "./WaybillDetail.vue?vue&type=script&lang=js&"
export * from "./WaybillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1abb5a2",
  null
  
)

export default component.exports